var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifictionsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#notifictionsMobile)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7268 16.6523L17.5364 15.4615V10.8462C17.5364 8.01231 16.0232 5.64 13.3842 5.01231V4.38462C13.3842 3.61846 12.766 3 12.0002 3C11.2343 3 10.6161 3.61846 10.6161 4.38462V5.01231C7.96789 5.64 6.46387 8.00308 6.46387 10.8462V15.4615L5.27356 16.6523C4.69225 17.2338 5.09825 18.2308 5.91946 18.2308H18.0716C18.9021 18.2308 19.3081 17.2338 18.7268 16.6523ZM15.691 16.3846H8.3093V10.8462C8.3093 8.55692 9.7026 6.69231 12.0002 6.69231C14.2977 6.69231 15.691 8.55692 15.691 10.8462V16.3846ZM12.0002 21C13.0151 21 13.8456 20.1692 13.8456 19.1538H10.1547C10.1547 20.1692 10.9759 21 12.0002 21Z",
    fill: "#295BB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notifictionsMobile"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifictionsMobile);
export default __webpack_public_path__ + "static/media/notifictionsMobile.bf72d2d6b5202d42f133273199910b03.svg";
export { ForwardRef as ReactComponent };